export const truncateAddress = (
  address: string | undefined,
  numChars: number = 5
): string | undefined =>
  address
    ? address.slice(0, numChars) + "..." + address.slice(-numChars)
    : undefined;
